import React,{useState,useEffect,useRef,useCallback } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import calender from '../../assets/images/calendar.png';
//import pluscircle from '../assets/images/plus-circle.png';
import { Circles } from 'react-loader-spinner';
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import axios from 'axios';
import { UPDATE_DRIVER,GET_STATE_URI,GET_PASSENGER_LIST,GET_EDIT_DRIVER,DELETE_ASSIGNED_PASSENGER } from '../../constant'; 
import { InputMask } from "primereact/inputmask";
import SaveButton  from '../../components/buttons/SaveButton';
import CancelButton from '../../components/buttons/CancelButton';
import {currentDateFormat,restrictZipInput} from "../../utils";
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { toast ,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import ConfirmPasswordNormal from '../../components/ConfirmPasswordNormal';
import{driverFormValidation} from "../../validation/Validation";
import { useNavigate} from "react-router-dom";
import Calender from "../../components/Calendar";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import Loader from '../../components/loader/Loader';

function DriverEdit({roleType}) {
    const { id } = useParams();
    const isOfficeAdmin = roleType === 'officeAdmin';
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const navigate = useNavigate();
    let currentInputIndex = 0;
    //const [loading, setLoading]  = useState(false);
    const [birthDate, setBirthDate] = useState();
    const [lisenceExpiryDate,setLisenceExpiryDate] = useState();
    const [hireDate,setHireDate] = useState(new Date());
    const [renewalDate,setRenewalDate] = useState(new Date());
    const [currentDate,setCurrentDate] = useState(new Date());
    const [stateData, setStateData] = useState([]);
    const formRef  = useRef({});
    const [passengerDetails,setPassengerDetails] = useState([]);
    const [myArray, setMyArray] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [editPassengerDetails,setEditPassengerDetails] = useState();
    const [viewDetails,setViewDetails]=useState();
    const [errors,setErrors] = useState({});
    const [driverDetails,setDriverDetails] = useState({
        first_name:'',
        middle_name:'',
        last_name:'',
        preferred_name:'',
        gender:'',
        passengerIds:[],
        ssn_number:'',
        umpi_number:'',
        hire_date:'',
        expiry_date:'',
        renewal_date:'',
        address_line_one:'',
        address_line_two:'',
        state:'',
        zip:'',
        city:'',
        home_phone:'',
        cell_phone:'',
        pick_phone:'',
        alternative_phone:'',
        email_address:'',
        date_of_birth:'',
        e_first_name:'',
        e_last_name:'',
        e_cell_number:'',
        e_email:'',
        u_nme:'',
        u_pswd:'',
        c_pswd:'',
        is_edit:'1',
    user_id:'',
    roleType:roleType});

        
      
        const inputRef = useRef(null);
        
        const handleFormSubmit = useCallback(async (e) => {
           
            e.preventDefault();
            
            const isValid =    driverFormValidation(driverDetails,roleType);
            console.log('isValid:', isValid);
            setErrors(isValid);
            if(Object.keys(isValid).length === 0){
               
            try {
                dispatch(setLoading(true));
                const response = await axios.post(UPDATE_DRIVER, driverDetails);
                if (response.data.status === '200') {
                    // console.log('response');
                    dispatch(setLoading(false));
                    Swal.fire({
                        title: 'Success!',
                        text: isOfficeAdmin ? "Office Admin updated successfully" : response.data.message ,
                        icon: 'success',
                        confirmButtonText: 'OK',
                      });
                      if(roleType === 'driver'){
                        navigate('/home/driver/list', { replace: true });
                      }
                      else{
                        navigate('/home/officeAdmin/list', { replace: true });
                      }
                     
                    
                } else {
                    dispatch(setLoading(false));
                    Swal.fire({
                        title: 'Error!',
                        text: isOfficeAdmin ? "Office Admin updated failed" : response.data.message ,
                        icon: 'Error',
                        confirmButtonText: 'OK',
                      });
                      
                }
            } catch (error) {
                dispatch(setLoading(false));
                console.error("Error logging in:", error);
            }
        }
          }, [driverDetails]);
        

        const loadUser = useCallback(async () => {
            dispatch(setLoading(true));
            const result = await axios.get(GET_PASSENGER_LIST);
            const response_2 = await axios.get(GET_EDIT_DRIVER + '/' + `${id}`);
            const response_state = await axios.get(GET_STATE_URI);
            setStateData(response_state.data);
            //console.log(response_2);
            setPassengerDetails(result.data);
            setViewDetails(response_2.data);
            setBirthDate(response_2.data?.driver?.user_dob);
            setHireDate(response_2.data?.driver?.driver?.hire_date);
            setLisenceExpiryDate(response_2.data?.driver?.driver?.lisence_expiry_date);
            setRenewalDate(response_2.data?.driver?.driver?.renewel_date);
            setEditPassengerDetails(response_2.data?.passengerDetails);
            //console.log("test driver details === ", response_2.data.driverDetails);
            //console.log("test = ",response_2.data.passenger.passenger_first_name);
            
            if (response_2.data?.driver !==0) {
               
                setDriverDetails({
                  first_name: response_2.data?.driver?.driver_first_name,
                  middle_name: response_2.data?.driver?.driver_middle_name,
                  last_name: response_2.data?.driver?.driver_last_name,
                  preferred_name:response_2.data?.driver?.preferred_name,
                  passengerIds:[],
                  gender:response_2.data?.driver?.gender,
                  date_of_birth: moment(response_2.data?.driver?.user_dob).format('DD/MM/yyyy'),
                    ssn_number:response_2.data?.driver?.driver?.ssn,
                    umpi_number:response_2.data?.driver?.driver?.umpi_no,
                    expiry_date:moment(response_2.data?.driver?.driver?.lisence_expiry_date).format('DD/MM/yyyy'),
                    hire_date:moment(response_2.data?.driver?.driver?.hire_date).format('DD/MM/yyyy'),
                    renewal_date:moment(response_2.data?.driver?.driver?.renewel_date).format('DD/MM/yyyy'),
                    address_line_one:response_2.data?.driver?.address_1,
                    address_line_two:response_2.data?.driver?.address_2,
                    city:response_2.data?.driver?.city,
                    state:response_2.data?.driver?.state,
                    zip:response_2.data?.driver?.zip,
                    home_phone:response_2.data?.driver?.driver?.home_phn_no,
                    cell_phone:response_2.data?.driver?.mobile_no,
                    pick_phone:'',
                    alternative_phone:response_2.data?.driver?.driver?.alternate_phn_no,
                    email_address:response_2.data?.driver?.user_email,
                    is_edit:'1',
                    e_first_name:response_2.data?.driver?.emergency_contact_name,
                    e_last_name:response_2.data?.driver?.emergency_contact_last_name,
                    e_cell_number:response_2.data?.driver?.emergency_phn,
                    e_email:response_2.data?.driver?.emergency_email,
                    u_nme:response_2.data?.driver?.login_user_name,
                    is_driver:response_2.data?.driver?.is_driver,
                    roleType:roleType,
                    // userIds: [...response_2.data.passengerDetails?.map((item)=>item.user_id.toString())],
                    driverId: id });
                    dispatch(setLoading(false));
        }
        else{
            console.log('no dat found..')
        }
          }, [id]);
    
          
    
        useEffect(() => {
              loadUser();
          }, []);

          
      
        // const generateInput = (e)=> {
        //     let inputcount = document.getElementsByName('e_name').length+1;
        //     e.preventDefault();
        //     const input = document.createElement('input');
        //     input.type = 'text';
        //     input.setAttribute('data-index',formRef.current.querySelectorAll('.my-3').length);
        //     input.classList.add('form-control', 'my-3');
        //     input.name = 'e_name';
        //     input.setAttribute('autocomplete', 'off'); 
        //     input.id='driver_' + inputcount;
        //     input.addEventListener('keyup', onChangeHandler);
        //     input.addEventListener('change', handleInputChange);
        //     document.getElementById('inputs-section2').appendChild(input);
            
        //   }

                     const handleInputChange=(e)=>{
             const {name,value,type,checked}=e.target;
             
             // Clear validation error for this field when user starts typing
             setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
             
             if (name === 'umpi_number') {
                 const alphanumericPattern = /^[A-Za-z0-9]*$/;
                 if (!alphanumericPattern.test(value)) {
                   setErrors((prevErrors) => ({
                     ...prevErrors,
                     umpi_number: 'UMPI Number should only contain alphanumeric characters.',
                   }));
                   return;
                 }
               }
             
             setDriverDetails((prev)=>{
                 return{
                  ...prev,
                   [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
                 passengerIds:  Array.from(formRef.current.querySelectorAll('.my-3')).map((input) => input.value  ),
                //Ids:  inputRef.current.dataset.code
                 }
             });
             
         }
        
        const handleBeforeInput = (e) => {
            const alphanumericPattern = /^[A-Za-z0-9]*$/;
            if (!alphanumericPattern.test(e.data)) {
              e.preventDefault();
            }
          };
        // const handleHiddenInputChange=(e)=>{
        //     //console.log(formRef.current.querySelectorAll('.user_id'));
        //     setDriverDetails((prev)=>{
        //         return{
        //             ...prev,
        //         userId:  Array.from(formRef.current.querySelectorAll('.user_id')).map((input) => input.value  ),
        //        //Ids:  inputRef.current.dataset.code
        //         }
        //     });
       
        // }
      
        // const onSuggestHandler = (text,id) => {
           
        //     currentInputIndex= localStorage.getItem('InputIndex') || 0;
        //     const passengerDetails=driverDetails.passengerIds.map((value,index)=>{
        //         if(index == currentInputIndex)
        //             { 
        //              return {text,id};}
        //          else{ return value; }
        //     });
            
        //     setMyArray((prevData) => {
        //         return [...prevData, id]; // spread the previous array and add the new id
        //       });

        //       const prevArray = [...myArray, id];
        //       setDriverDetails((prev)=>{
        //         return{
        //          ...prev,
        //         passengerIds:  [...passengerDetails],
        //         userIds: [...prevArray, ...editPassengerDetails.map((item)=>item.user_id.toString())]
        //         //userIds: [...myArray, id]
        //         }
                
        //     });
        //       //handleHiddenInputChange();
        //     userSuggestionData(passengerDetails);
        //     setSuggestions([]);
        //   };
          
        //   const userSuggestionData = (passenger)=>{
           
        //      var inputs = document.querySelectorAll('.my-3');
        //         for (var i = 0; i < inputs.length; i++) {
        //             //inputs[i].value = passenger[i] || '';
        //             if (typeof passenger[i] === 'string') {
        //                 inputs[i].value = passenger[i];
        //               } else if (typeof passenger[i] === 'object') {
        //                 inputs[i].value = passenger[i].text || '';
        //               } else {
        //                 inputs[i].value = '';
        //               }
        //         }
        //     }

        //   const onChangeHandler = (e)=>{
        //     console.log('Key up event triggered:', e.target);
        //     let text = e.target.value ? e.target.value : "";
        //     let inputIndex = e.target.dataset.index;
        //     localStorage.setItem('InputIndex',inputIndex);
        //     //console.log( e.target);
        //         let matches = [];
        //         if(text.length > 0){
        //             matches = passengerDetails.filter(user =>{
        //                 const regex = new RegExp(`${text}`,"gi");
        //                 return user.first_name.match(regex) || user.user_id.toString().match(regex);
        //             })
        //         }
        //         setSuggestions(matches);
        //        //console.log(matches);
        //   }
          const deleteDriver=(userId)=>{
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this item!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it'
              }).then((result) => {
                if (result.isConfirmed) {
        
                    axios.delete(DELETE_ASSIGNED_PASSENGER + '/' + `${userId}`)
                    .then((response)=>{
                        if(response.data.status === 200){
                            toast.success(response.data.message, { position: "top-center" });
                            setEditPassengerDetails(
                                editPassengerDetails.filter(a =>
                                  a.user_id !== `${userId}`
                                )
                              );
                        }else{
                            toast.error(response.data.message, { position: "top-center" });
                        }
                        //console.log(response);
                    }).catch(error => {
                        toast.error(error, { position: "top-center" });
                      })
                }
              });
                
             }     

        
  return (
    <><div className="tab-pane fade active show" id="add-driver" role="tabpanel" aria-labelledby="driver-tab">
          <div className="container-fluid px-mobile-2">

              <section>

                  <div className='d-flex justify-content-between form-container'>
                      <div>
                            <h2 className="fs-5 font-weight-600"> {isOfficeAdmin ? 'Edit Office Admin' : 'Edit Driver'}</h2>
                        </div>
                      <div>
                          <ToastContainer />
                      </div>
                      <div>
                          <span>{currentDateFormat(currentDate)}</span>
                      </div>
                  </div>
              </section>
              <section>
                  <div className='bg-white  px-5 py-4'>
                      <div>
                          <p className="pt-2 sub-title">Personal Information</p>
                      </div>
                      <form onSubmit={handleFormSubmit} ref={formRef}>
                          <div className="form-items">
                              <div>
                                  <label className='require-field'>First Name</label>
                                  <input type="text" autoComplete='off' value={driverDetails.first_name || ''} className="form-control" id="first_name" name="first_name" placeholder="" onChange={handleInputChange} />
                                  {errors.first_name && <span className='errors'>{errors.first_name}</span> }
                              </div>
                              <div>
                                  <label>Middle Name</label>
                                  <input type="text" autoComplete='off' value={driverDetails.middle_name || ''} className="form-control" id="middle_name" name="middle_name" placeholder="" onChange={handleInputChange} />
                              </div>
                              <div>
                                  <label className='require-field'>Last Name</label>
                                  <input type="text" autoComplete='off' value={driverDetails.last_name || ''} className="form-control" id="last_name" name="last_name" placeholder="" onChange={handleInputChange} />
                                  {errors.last_name && <span className='errors'>{errors.last_name}</span> }
                              </div>
                              <div>
                                  <label>Preferred Name</label>
                                  <input type="text" autoComplete='off' value={driverDetails.preferred_name || ''} className="form-control" id="preferred_name" name="preferred_name" placeholder="" onChange={handleInputChange} />
                              </div>
                              <div>
                                  <label className='require-field'>Gender</label>
                                  <div>
                                      <select className="form-select" aria-label="Default select example" value={driverDetails?.gender ?? ''} name="gender" onChange={handleInputChange}>
                                          <option value="">Select</option>
                                          <option value="1">Male</option>
                                          <option value="2">Female</option>
                                      </select>
                                  </div>
                                  {errors.gender && <span className='errors'>{errors.gender}</span> }
                              </div>
                              <div className="date-selector">
                                  <label className='require-field'>Date of Birth</label>
                                  
                                  <Calender
                                      selected={birthDate}
                                      dateFormat="MM/dd/yyyy"
                                      onChange={handleInputChange}
                                      setDate={setBirthDate}
                                      name="date_of_birth"
                                      id="date_of_birth"
                                      errors={errors.date_of_birth} />
                              </div>
                              <div>
                                  <label>SSN</label>
                                  <input type="text" autoComplete='off' value={driverDetails.ssn_number || ''} className="form-control" id="ssn_number" name="ssn_number" onChange={handleInputChange} placeholder="" />
                              </div>
                              <div>
                                  <label >UMPI Number</label>
                                  <input type="text" 
                                  autoComplete='off' 
                                  value={driverDetails.umpi_number || ''} 
                                  className="form-control" 
                                  id="umpi_number" 
                                  name="umpi_number" 
                                  onChange={handleInputChange} 
                                  placeholder="" 
                                  maxLength="10"
                                  onBeforeInput={handleBeforeInput}
                                  />
                                  {errors.umpi_number && <span className='errors'>{errors.umpi_number}</span> }
                              </div>
                              <div>
                                <div className="date-selector grid-span">
                                    <label>Driver License Expiry Date</label>
                                     <Calender 
                                        selected={lisenceExpiryDate}
                                        onChange={handleInputChange}
                                        setDate = {setLisenceExpiryDate}
                                        name= "expiry_date"
                                        id= "expiry_date"
                                        errors={errors.expiry_date}
                                    />
                                </div>
                            </div>
                              <div>
                                  <div className="date-selector">
                                      <label>Hire Date</label>
                                      
                                      <Calender
                                          selected={hireDate}
                                          onChange={handleInputChange}
                                          setDate={setHireDate}
                                          name="hire_date"
                                          id="hire_date"
                                          errors={errors.hire_date} />
                                  </div>
                              </div>
                              <div>
                                  <div className="date-selector">
                                      <label>Renewal Date</label>
                                      
                                      <Calender
                                          selected={renewalDate}
                                          onChange={handleInputChange}
                                          setDate={setRenewalDate}
                                          name="renewal_date"
                                          id="renewal_date"
                                          errors={errors.renewal_date} />
                                  </div>
                              </div>
                              <div>
                                  <label className='require-field'>Address Line 1</label>
                                  <input type="text" autoComplete='off' value={driverDetails.address_line_one || ''} className="form-control" id="address_line_one" name="address_line_one" onChange={handleInputChange} placeholder="" />
                                  {errors.address_line_one && <span className='errors'>{errors.address_line_one}</span> }
                              </div>
                              <div>
                                  <label>Address Line 2</label>
                                  <input type="text" autoComplete='off' value={driverDetails.address_line_two || ''} className="form-control" id="address_line_two" name="address_line_two" onChange={handleInputChange} placeholder="" />
                              </div>
                              <div>
                                  <label className='require-field'>City</label>
                                  <input type="text" autoComplete='off' value={driverDetails.city || ''} className="form-control" id="city" name="city" placeholder="Minneapolis" onChange={handleInputChange} />
                                  {errors.city && <span className='errors'>{errors.city}</span> }
                              </div>
                              <div>
                                  <label className='require-field'>State</label>
                                  <select className="form-select" value={driverDetails.state ?? ''} onChange={handleInputChange} aria-label="Default select example" id='state' name="state">
                                      <option value="">Select</option>
                                      {stateData.map((state, index) => (
                                          <option key={index} value={state?.state_id}>{state?.state_name}</option>
                                      ))}
                                  </select>
                                  {errors.state && <span className='errors'>{errors.state}</span> }
                              </div>
                              <div>
                                  <label className='require-field'>Zip</label>
                                  <input type="text" autoComplete='off' onInput={restrictZipInput} value={driverDetails.zip || ''} className="form-control" id="zip" name="zip" placeholder="" onChange={handleInputChange} />
                                  {errors.zip && <span className='errors'>{errors.zip}</span> }
                              </div>
                              <div>
                                  <label >Home Phone Number</label>
                                  <InputMask className="form-control" value={driverDetails.home_phone || ''} autoComplete='off' mask="(999) 999-9999" id="home_phone" name="home_phone" onChange={handleInputChange}></InputMask>
                                  {errors.home_phone && <span className='errors'>{errors.home_phone}</span> }
                              </div>
                              <div>
                                  <label>Cell Phone Number</label>
                                  <InputMask className="form-control" value={driverDetails.cell_phone || ''} autoComplete='off' mask="(999) 999-9999" id="cell_phone" name="cell_phone" onChange={handleInputChange}></InputMask>
                                  {errors.cell_phone && <span className='errors'>{errors.cell_phone}</span> }
                                  {/* <div className="form-check pt-2">
                                      <input className="form-check-input" type="checkbox" value="" onChange={handleInputChange} id="pick-up-phone" name="pick_phone" />
                                      <label className="form-check-label" htmlFor="flexCheckDefault">
                                          Pick Up Phone
                                      </label>
                                  </div> */}
                              </div>
                              <div>
                                  <label>Alternate Phone Number</label>
                                  <InputMask className="form-control" value={driverDetails.alternative_phone || ''} autoComplete='off' mask="(999) 999-9999" id="alternative_phone" name="alternative_phone" onChange={handleInputChange}></InputMask>
                              </div>
                              <div className="form-item">
                                  <label>Email Address</label>
                                  <input type="email" autoComplete='off' value={driverDetails.email_address || ''} className="form-control" id="email_address" name="email_address" onChange={handleInputChange} placeholder="" />
                              </div>
                          </div>
                          {/* <div className="my-4">
                              <p className='sub-title'>Emergency Contact Information</p>

                              <div className="form-items">
                                  <div>
                                      <label>First Name</label>
                                      <input type="text" autoComplete='off' value={driverDetails.e_first_name || ''} className="form-control" id="e_first_name" name="e_first_name" onChange={handleInputChange} placeholder="" />
                                  </div>
                                  <div>
                                      <label>Last Name</label>
                                      <input type="text" autoComplete='off' value={driverDetails.e_last_name || ''} className="form-control" id="e_last_name" name="e_last_name" onChange={handleInputChange} placeholder="" />
                                  </div>
                                  <div>
                                      <label>Cell Phone Number</label>
                                      <InputMask className="form-control" value={driverDetails.e_cell_number || ''} autoComplete='off' mask="(999) 999-9999" id="e_cell_number" name="e_cell_number" onChange={handleInputChange}></InputMask>

                                  </div>
                                  <div className="form-item">
                                      <label>Email Address</label>
                                      <input type="email" autoComplete='off' value={driverDetails.e_email || ''} className="form-control" id="e_email" name="e_email" onChange={handleInputChange} placeholder="" />
                                  </div>
                              </div>
                          </div> */}
                          {
                        isOfficeAdmin && (
                            <div className="py-3">
                                <label>&nbsp;</label>
                                <div className="form-check">
                                                                         <input 
                                         type="checkbox" 
                                         className="form-check-input" 
                                         name="is_driver" 
                                         id="is_driver" 
                                         onChange={handleInputChange} 
                                         checked={driverDetails.is_driver === 1}
                                     />
                                    <label className="form-check-label" htmlFor="is_driver">
                                        Mark as Driver
                                    </label>
                                </div>
                            </div>
                        )
                       }
                          <div className="py-3">
                              <p className='sub-title'>Login Credentials</p>

                              <div className="form-items">
                                  <ConfirmPasswordNormal handleInputChange={handleInputChange} errors={errors} isEditMode='1' defaultValue={viewDetails?.driver?.login_user_name ?? ''} />

                              </div>
                          </div>
                          {/* <div className="py-3">
                              <p className='sub-title'>Assign Passengers</p>
                              <div className="row">
                                  <div className="col-lg-3 col-md-4 col-sm-10 pe-0">
                                      <div className="d-flex align-items-center">
                                          <div id="inputs-section2">
                                              <input type="text" data-index='0' ref={inputRef} autoComplete='off'

                                                  className="form-control my-3" value={driverDetails.passengerIds[0] ? driverDetails.passengerIds[0].text : ''} id="e_name" name="e_name" onChange={(e) => {

                                                      handleInputChange(e);
                                                  } } onKeyUp={onChangeHandler} />
                                              {suggestions && suggestions.map((item, index) => (
                                                  <div key={index} onClick={() => onSuggestHandler((item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.passenger?.pass_pmi_no), item.user_id.toString())}>
                                                      <p> {item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.passenger?.pass_pmi_no}</p>
                                                  </div>
                                              ))}

                                              {console.log(driverDetails.passengerIds[0] ? driverDetails.passengerIds[0] : '')}
                                              <input type="hidden" className='user_id' name="user_ids" onChange={handleHiddenInputChange} value={JSON.stringify(myArray)} />
                                          </div>
                                          <div style={{ alignSelf: 'end' }}>
                                              <p><i className="pi pi-plus-circle assigned-btn" onClick={generateInput}></i></p>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6 col-lg-6 assigned-top-padding">
                                      <div className='row'>
                                          <div className='col-md-8 col-lg-8 assigned-drivers-sector'>
                                              {editPassengerDetails && editPassengerDetails.map((passenger) => {
                                                  return (
                                                      <div key={passenger.user_id} className="driver-list-item d-flex gap-3 align-items-center">
                                                          <div className='mb-3'>
                                                              <input type="text" 
                                                              readOnly 
                                                              style={{ background: 'rgb(233 227 227)' }} 
                                                              name="driver_list" 
                                                              className="form-control" 
                                                              defaultValue={passenger?.first_name +' '+passenger?.middle_name+' '+ passenger?.last_name} />
                                                          </div>
                                                          <div style={{ alignSelf: 'flex-start' }}>
                                                              <i className="pi pi-trash icon-btn-delete fs-6"
                                                                  style={{ position: 'relative', top: '10px' }}
                                                                  onClick={() => deleteDriver(passenger.user_id)}
                                                              ></i>
                                                          </div>
                                                      </div>);
                                              })}
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div> */}
                          <div className='footer-content'>
                              <SaveButton type='submit' buttonTitle={isOfficeAdmin ? 'UPDATE OFFICE ADMIN' : 'UPDATE DRIVER'} />

                              <CancelButton cancelHandler={() => navigate(isOfficeAdmin ? '/home/officeAdmin/list' : '/home/driver/list', { replace: true })} />
                          </div>
                      </form>
                  </div>
              </section>
          </div>
      </div><div>
              {loading && <Loader />}
          </div></>
  )
}

export default DriverEdit